import React from 'react';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { get } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/AddBox';
import PeopleIcon from '@material-ui/icons/People';
import VerticalTopIcon from '@material-ui/icons/VerticalAlignTop';
import TimeIcon from '@material-ui/icons/AccessTime';
import DoneIcon from '@material-ui/icons/Done';
import WrenchIcon from '@material-ui/icons/Build';
import HelpdeskIcon from '@material-ui/icons/HeadsetMic';
import { Link } from 'react-router-dom';
import { overview } from './_api';

const styles = (theme) => ({
  root: {
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  tile: {
    width: 200,
    height: 200,
    margin: theme.spacing.unit * 2,
    background: '#fff',
    border: '1px solid #f9f9f9',
    display: 'flex',
    justifyContent: 'flex-start',
    paddingTop: 60,
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: '0 0 3px 3px #eee',
    transition: 'all .1s linear',
    flexDirection: 'column',
    padding: theme.spacing.unit,
    textDecoration: 'none',
    color: 'inherit',
    fontSize: 16,
    '&:hover': {
      background: '#eee',
      boxShadow: '0 0 4px 4px #ddd',
    },
  },
  icon: {
    fontSize: 36,
  },
  value: {
    fontWeight: 'bold',
    fontSize: 32,
    marginTop: 12,
    color: '#3f51b5',
    width: '100%',
    textAlign: 'center',
    borderTop: '1px solid #e4e4e4',
    paddingTop: 7,
  },
});

const enhance = compose(
  withStyles(styles),
  withState('overviewItems', 'setOverviewItems', {}),
  withHandlers({}),
  lifecycle({
    async componentDidMount() {
      try {
        const overviewItems = await overview();
        this.props.setOverviewItems(overviewItems);
      } catch (e) {
        // Nothing
      }
    },
  })
);

export default enhance(({ classes, overviewItems }) => (
  <div className={classes.root}>
    <Link to="/reservations" className={classes.tile}>
      <div className={classes.icon}>
        <AddIcon style={{ fontSize: 48 }} />
      </div>
      <div>Nová rezervace</div>
    </Link>
    <Link to="/item-services/new" className={classes.tile}>
      <div className={classes.icon}>
        <WrenchIcon style={{ fontSize: 48 }} />
      </div>
      <div>Nový servis</div>
    </Link>
    <Link to="/users" className={classes.tile}>
      <div className={classes.icon}>
        <PeopleIcon style={{ fontSize: 48 }} />
      </div>
      <div>Adresář</div>
    </Link>
    <Link to="/reservations/unreturned" className={classes.tile}>
      <div className={classes.icon}>
        <TimeIcon style={{ fontSize: 48 }} />
      </div>
      <div>Opožděná vrácení</div>
      <div className={classes.value}>{get(overviewItems, 'lateReturns', 0)}</div>
    </Link>
    <Link to="/reservations" className={classes.tile}>
      <div className={classes.icon}>
        <VerticalTopIcon style={{ fontSize: 48 }} />
      </div>
      <div>Nevyzvednuto</div>
      <div className={classes.value}>{get(overviewItems, 'notPickedUp', 0)}</div>
    </Link>
    <Link to="/reservations/active" className={classes.tile}>
      <div className={classes.icon}>
        <DoneIcon style={{ fontSize: 48 }} />
      </div>
      <div>Probíhající výpůjčky</div>
      <div className={classes.value}>{get(overviewItems, 'ongoing', 0)}</div>
    </Link>
    <Link to="/helpdesk" className={classes.tile}>
      <div className={classes.icon}>
        <HelpdeskIcon style={{ fontSize: 48 }} />
      </div>
      <div>Helpdesk</div>
    </Link>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/homepage/index.js